var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.352 -0.492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.352 0.492)",
    fill: "#fff",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.5,
    rx: 30,
    ry: 29.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.5,
    rx: 28.5,
    ry: 28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.183,24.344.4,15.556a1.352,1.352,0,0,1,0-1.912l1.912-1.912a1.352,1.352,0,0,1,1.912,0l5.92,5.919L22.818,4.973a1.352,1.352,0,0,1,1.912,0l1.912,1.912a1.352,1.352,0,0,1,0,1.912L11.1,24.344A1.352,1.352,0,0,1,9.183,24.344Z",
    transform: "translate(16.223 15.083)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c6d18c7cf7f3a3aa94930771f4ca914d.svg";
export { ForwardRef as ReactComponent };